import { Component, Input } from '@angular/core';
import * as _ from 'lodash';
import { UrlSerializer, RouterLink } from '@angular/router';
import { DirectionService } from '@app/_services/direction.service';
import { TranslateService } from '@ngx-translate/core';
import { Support } from '@app/_helpers';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-block-banner',
    templateUrl: './block-banner.component.html',
    styleUrls: ['./block-banner.component.scss'],
    standalone: true,
    imports: [NgIf, RouterLink]
})
export class BlockBannerComponent {
    @Input() banner;
    @Input() fullWidth: any = false;
    @Input() rounded: any = false;

    image;


    url;
    params;
    constructor(private urlSerializer: UrlSerializer,
        public direction: DirectionService,
        public translate: TranslateService,

    ) {
    }

    ngOnInit() {
        this.fullWidth = Support.numberToBoolean(this.fullWidth);

        if (this.banner?.images) {
            this.image = this.banner.images?.[this.translate.currentLang]?.url || this.banner.images?.["en"]?.url
        }
        if (this.banner?.url?.[this.translate.currentLang] && !this.banner.external) {
            let splitedUrl = _.split(this.banner.url[this.translate.currentLang], '?');
            this.url = splitedUrl[0];
            this.params = this.urlSerializer.parse(this.banner.url[this.translate.currentLang]).queryParams;


        }
    }

}
